/**
 * Copyright Mántum All Rights Reserved.
 */
import Breadcrumb from '../../components/common/breadcrumb';
import Button from '../../components/common/button/contained';

import type { Path } from '@mantum/kanela';

type PropTypes = {
    action?: string;
    children?: React.ReactNode;
    className?: string;
    description?: string | React.ReactNode;
    enabled?: boolean;
    home?: string;
    onClick?: () => void;
    onNavegation?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    path?: Path[];
    title?: string;
};

export default function Page(props: PropTypes) {
    // prettier-ignore
    const {
        enabled = false 
    } = props;

    return (
        <div className='relative h-full w-full overflow-auto'>
            <div className={`mr-0 md:p-4 ${props.className ?? ''}`}>
                <div className='mx-auto w-full p-6 sm:p-8'>
                    <div className='mb-2 lg:flex lg:items-center lg:justify-between'>
                        <div className='min-w-0 flex-1'>
                            <div className='mb-4'>
                                <Breadcrumb
                                    onClick={props.onNavegation}
                                    path={props.path}
                                    title={props.home}
                                />
                            </div>
                            <div className='flex flex-col items-start gap-4 sm:flex-row sm:justify-between sm:gap-0'>
                                <div className='w-full'>
                                    <h2 className='basis-3/4 text-2xl font-medium leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight'>
                                        {props.title}
                                    </h2>
                                    <p className='text-sm text-slate-600'>
                                        {props.description}
                                    </p>
                                </div>
                                {enabled && (
                                    <div className='flex w-full flex-row flex-nowrap justify-end'>
                                        <div className='max-w-min'>
                                            <Button
                                                onClick={props.onClick}
                                                testid='register'
                                            >
                                                {props.action}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>{props.children}</div>
                </div>
            </div>
        </div>
    );
}
